import cdb from './data/swissCdb2020';
import commentary from './data/swissCdb2020Commentary';

const documents = [cdb, commentary];
const numberedArticles = new Map(documents.map(document => [document.id,
  new Map(document.chapters.flatMap(chapter => chapter.articles
    .filter(article => /^\d+$/.test(String(article.number)))
    .map(article => [String(article.number), { chapter, article }])))
]));

// Match numbered entries only: introductions and case studies are not counterparts.
export function getCdbArticleLink(documentId, articleNumber) {
  const source = numberedArticles.get(documentId);
  const number = String(articleNumber);
  if (!source?.has(number)) return null;
  const targetId = documentId === cdb.id ? commentary.id : cdb.id;
  const target = numberedArticles.get(targetId).get(number);
  return target ? {
    ...target,
    documentId: targetId,
    label: targetId === commentary.id ? 'View commentary' : 'View CDB article',
  } : null;
}
